/**
 * Ce qui, dans une série de douze mois, concerne réellement le locataire.
 *
 * Sur l'espace locataire, une valeur antérieure à son entrée n'est pas « une
 * donnée de moins d'intérêt » : c'est une dépense qui n'est pas la sienne, et
 * qu'il pourrait croire lui être imputée. Les mois d'avant sont donc laissés
 * VIDES, jamais mis à zéro — un zéro se lit comme « rien consommé ».
 *
 * Une seule définition, partagée par les graphiques de consommation et par
 * celui des dépenses : deux copies finiraient par découper deux mois
 * différents.
 */

/** Masque les valeurs d'une série de douze mois antérieures à l'entrée.
 *
 * Le mois d'entrée est CONSERVÉ même s'il est entamé : entré le 15 août, le
 * locataire a bien consommé en août. Le découper au prorata serait une
 * précision que la facture mensuelle ne porte pas.
 *
 * `entree` nulle (propriétaire, ou date inconnue) ne masque rien : c'est le
 * comportement de l'écran propriétaire, qui voit tout.
 */
export const masquerAvantEntree = (
  valeurs: (number | null)[],
  annee: number,
  entree: Date | null,
): (number | null)[] => {
  if (!entree || Number.isNaN(entree.getTime())) return valeurs;
  const anneeEntree = entree.getFullYear();
  if (anneeEntree < annee) return valeurs;
  // Bail à venir : rien de cette année ne le concerne encore.
  if (anneeEntree > annee) return valeurs.map(() => null);
  return valeurs.map((v, i) => (i < entree.getMonth() ? null : v));
};
